<template>
  <div
    v-if="popupContent"
    id="popup"
    style="background-color: rgba(255, 255, 255, 0.97);"
    class="fixed tl-0 w-full h-100vh noselect z100"
  >
    <!-- sisältö -->
    <div id="popup-content"> <!-- ks. myös css -->
      <div :style="{ backgroundImage: 'url(' + popupContent.img + ')' }" class="flex flex-center">
      </div>
    </div>

    <!-- popup-tbar -->
    <div id="popup-tbar" class="absolute tl-0 w-full flex"> <!-- ks. myös css -->
      <div class="wrapper flex align-center flex-1">
        <div class="flex flex-1 align-center h-2 color-white">

          <!-- vanhat zoominapit - älä poista vielä! -->
          <!-- <i @click="zoom = Math.round((zoom + 0.2) * 10)/10" :class="{ noselect: zoom >= 2 }" class="material-icons font-20 mr-1">zoom_in</i>
          <i @click="zoom = Math.round((zoom - 0.2) * 10)/10" :class="{ noselect: zoom <= 1 }" class="material-icons font-20 mr-4">zoom_out</i> -->

          <div v-if="popupContent.imgText" @click="imgText = !imgText" class="flex align-center pointer">
            <span class="txt-bold mr-1">kuvateksti</span>
            <i v-if="imgText" class="material-icons font-11">expand_more</i>
            <i v-else class="material-icons font-11">expand_less</i>
          </div>
        </div>
        <i @click="closePopup" class="material-icons font-20 color-white">close</i>
      </div>
    </div>

    <!-- kuvateksti -->
    <div v-show="popupContent.imgText && !imgText" id="popup-text" :class="$mq" class="absolute l-0 w-full pt-4 lheight-16 font-10" style="background-color: rgba(255, 255, 255, 0.85);"> <!-- ks. myös css -->
      <div v-html="popupContent.imgText" class="popup-image-text-field mx-auto" style="padding: 0 25px; max-width: 1100px;"></div>
      <!-- <div class="mx-auto" style="padding: 0 25px; max-width: 1100px;">{{ popupContent.imgText }}</div> -->
      <div @click="imgText = !imgText" class="flex justify-center pointer"><i class="material-icons">expand_less</i></div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'popupContent',

  data () {
    return {
      imgText: false
      // zoom: 1
    }
  },

  computed: {
    ...mapState(['popupContent'])
  },

  methods: {
    ...mapActions(['setPopupContent']),

    closePopup () {
      // this.zoom = 1
      this.$router.push(-1)
      this.$store.dispatch('setPopupContent', null)
    }

    /* controlZoom(scale) {
      this.zoom = this.zoom + scale
    } */
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#popup-content {
  overflow: auto;
  position: relative;
  top: $Tbar-height;
  height: calc(100vh - #{$Tbar-height});
  & > div {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
}
#popup-tbar {
  height: $Tbar-height;
  background-color: color(ui-main);
  box-shadow: 0 1.5px 2px rgba(0, 0, 0, 0.2);
  .noselect {
    pointer-events: none;
    opacity: 0.4;
  }
}
#popup-text {
  top: $Tbar-height;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  &.phone {
    font-size: 0.85rem !important;
  }
}
</style>
